<template>
  <div class="users">
    <Header :right-sidebar="true" right-sidebar-title="Пользователи">
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="displayableUsersFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="usersFields"
            :items="users"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item variant="success" to="/users/create">
          Добавить пользователя
          <template #icon>
            <b-icon icon="plus-square" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <b-overlay :show="!loaded">
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          @row-clicked="item => openUser(item)"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import { displayableFields } from "@/components/Tables/defaultFields";
import { usersFields } from "@/views/Users/models/usersTable";
import { mapGetters } from "vuex";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    SidebarItem,
    FiltersGroup,
    SidebarItemsGroup,
    FieldsPicker,
    Main,
    Header
  },
  mixins: [pageTitleMixin],
  data() {
    let displayableUsersFields = displayableFields(usersFields);
    return {
      usersFields,
      displayableUsersFields,
      filteredItems: [],
      pickedFields: displayableUsersFields
    };
  },
  computed: {
    ...mapGetters("users", ["users", "loaded"]),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    openUser({ id }) {
      this.$router.push(`/users/${id}`);
    }
  }
};
</script>
